import React from 'react';
export function MediaFeature() {
  return <section id="media" className="py-24 bg-brand-dark text-white" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-36">
          {/* Left Content */}
          <div data-id="element-37">
            <img src="https://cdn.magicpatterns.com/uploads/kCPcHxW7bqbU35oagdf2XB/630c0151d35f34759065b745_partner-1.png" alt="Eater San Diego" className="h-8 object-contain mb-6" data-id="element-38" />
            <div className="block font-display font-bold text-brand-gold tracking-widest uppercase text-sm mb-3" data-id="element-39">
              As Seen On
            </div>
            <h2 className="font-display font-extrabold text-white text-4xl md:text-5xl mb-6 uppercase" data-id="element-40">
              Featured on CBS 8 News
            </h2>
            <p className="text-brand-cream/80 text-lg leading-relaxed mb-8" data-id="element-41">
              National City's beloved food hall caught the attention of CBS 8
              News. Watch the feature to see what makes Market on 8th a true
              community landmark — and why locals keep coming back.
            </p>
            <a href="https://www.instagram.com/marketon8thst/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-sans text-xs font-bold uppercase tracking-[0.1em] text-brand-gold hover:text-brand-yellow transition-colors" data-id="element-42">
              Follow @marketon8thst &rarr;
            </a>
          </div>

          {/* Right Video */}
          <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-2xl border border-white/10" data-id="element-43">
            <iframe src="https://www.youtube.com/embed/vBR_FzC9gN4" title="Market on 8th — CBS 8 News Feature" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute top-0 left-0 w-full h-full" data-id="element-44"></iframe>
          </div>
        </div>
      </div>
    </section>;
}